import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStreamersResponseV2 } from '@/src/v2/service/v2/graphql/generated/gql-api.generated';

export interface StreamMapState {
  [id: string]: {
    timestamp: number | null;
    isPin: boolean;
    id: string;
    stream: IStreamersResponseV2;
    volume: number;
  };
}

const initialState: StreamMapState = {};

const streamMapSlice = createSlice({
  name: 'streamMap',
  initialState,
  reducers: {
    initStreamMap: (state, action: PayloadAction<StreamMapState>) => {
      return { ...action.payload };
    },
    modifyStreamMap: (
      state,
      action: PayloadAction<{
        id: string;
        setup: Partial<StreamMapState[string]>;
      }>
    ) => {
      const { id, setup } = action.payload;
      if (state[id]) {
        state[id] = { ...state[id], ...setup };
      }
    },
  },
});

export const { initStreamMap, modifyStreamMap } = streamMapSlice.actions;
export default streamMapSlice.reducer;
